var _feOffset, _feGaussianBlur, _feColorMatrix, _feOffset2, _feGaussianBlur2, _feColorMatrix2, _feOffset3, _feGaussianBlur3, _feColorMatrix3, _feOffset4, _feGaussianBlur4, _feColorMatrix4, _feOffset5, _feGaussianBlur5, _feColorMatrix5, _feOffset6, _feGaussianBlur6, _feColorMatrix6, _feOffset7, _feGaussianBlur7, _feColorMatrix7, _feOffset8, _feGaussianBlur8, _feColorMatrix8, _feOffset9, _feGaussianBlur9, _feColorMatrix9, _feOffset10, _feGaussianBlur10, _feColorMatrix10, _feOffset11, _feGaussianBlur11, _feColorMatrix11, _feOffset12, _feGaussianBlur12, _feColorMatrix12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgBgMagicIcon(props) {
  const _id24 = useUniqueInlineId();
  const _id23 = useUniqueInlineId();
  const _id22 = useUniqueInlineId();
  const _id21 = useUniqueInlineId();
  const _id20 = useUniqueInlineId();
  const _id19 = useUniqueInlineId();
  const _id18 = useUniqueInlineId();
  const _id17 = useUniqueInlineId();
  const _id16 = useUniqueInlineId();
  const _id15 = useUniqueInlineId();
  const _id14 = useUniqueInlineId();
  const _id13 = useUniqueInlineId();
  const _id12 = useUniqueInlineId();
  const _id11 = useUniqueInlineId();
  const _id10 = useUniqueInlineId();
  const _id9 = useUniqueInlineId();
  const _id8 = useUniqueInlineId();
  const _id7 = useUniqueInlineId();
  const _id6 = useUniqueInlineId();
  const _id5 = useUniqueInlineId();
  const _id4 = useUniqueInlineId();
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 377 423",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: `url(#${_id})`,
    xlinkHref: `#${_id13}`
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1253FA",
    xlinkHref: `#${_id13}`
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: `url(#${_id2})`,
    xlinkHref: `#${_id14}`
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1253FA",
    xlinkHref: `#${_id14}`
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: `url(#${_id3})`,
    xlinkHref: `#${_id15}`
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1253FA",
    xlinkHref: `#${_id15}`
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: `url(#${_id4})`,
    xlinkHref: `#${_id16}`
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1253FA",
    xlinkHref: `#${_id16}`
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: `url(#${_id5})`,
    xlinkHref: `#${_id17}`
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1253FA",
    xlinkHref: `#${_id17}`
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: `url(#${_id6})`,
    xlinkHref: `#${_id18}`
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1253FA",
    xlinkHref: `#${_id18}`
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: `url(#${_id7})`,
    xlinkHref: `#${_id19}`
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1253FA",
    xlinkHref: `#${_id19}`
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: `url(#${_id8})`,
    xlinkHref: `#${_id20}`
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1253FA",
    xlinkHref: `#${_id20}`
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: `url(#${_id9})`,
    xlinkHref: `#${_id21}`
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1253FA",
    xlinkHref: `#${_id21}`
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: `url(#${_id10})`,
    xlinkHref: `#${_id22}`
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1253FA",
    xlinkHref: `#${_id22}`
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: `url(#${_id11})`,
    xlinkHref: `#${_id23}`
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1253FA",
    xlinkHref: `#${_id23}`
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: `url(#${_id12})`,
    xlinkHref: `#${_id24}`
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1253FA",
    xlinkHref: `#${_id24}`
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-10.3%",
    y: "-6.4%",
    width: "120.5%",
    height: "115.9%",
    filterUnits: "objectBoundingBox",
    id: _id
  }, _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.511512284 0 0 0 0 0.515598878 0 0 0 0 0.526098279 0 0 0 0.07 0",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-12.1%",
    y: "-7.3%",
    width: "124.1%",
    height: "119.5%",
    filterUnits: "objectBoundingBox",
    id: _id2
  }, _feOffset2 || (_feOffset2 = /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.511512284 0 0 0 0 0.515598878 0 0 0 0 0.526098279 0 0 0 0.07 0",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-12.1%",
    y: "-7.3%",
    width: "124.1%",
    height: "119.5%",
    filterUnits: "objectBoundingBox",
    id: _id3
  }, _feOffset3 || (_feOffset3 = /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix3 || (_feColorMatrix3 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.511512284 0 0 0 0 0.515598878 0 0 0 0 0.526098279 0 0 0 0.07 0",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-6.8%",
    y: "-4.6%",
    width: "113.6%",
    height: "108.9%",
    filterUnits: "objectBoundingBox",
    id: _id4
  }, _feOffset4 || (_feOffset4 = /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur4 || (_feGaussianBlur4 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix4 || (_feColorMatrix4 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.511512284 0 0 0 0 0.515598878 0 0 0 0 0.526098279 0 0 0 0.07 0",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-2.9%",
    y: "-2.7%",
    width: "105.8%",
    height: "101.2%",
    filterUnits: "objectBoundingBox",
    id: _id5
  }, _feOffset5 || (_feOffset5 = /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur5 || (_feGaussianBlur5 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix5 || (_feColorMatrix5 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.511512284 0 0 0 0 0.515598878 0 0 0 0 0.526098279 0 0 0 0.07 0",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-6.8%",
    y: "-4.6%",
    width: "113.6%",
    height: "108.9%",
    filterUnits: "objectBoundingBox",
    id: _id6
  }, _feOffset6 || (_feOffset6 = /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur6 || (_feGaussianBlur6 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix6 || (_feColorMatrix6 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.511512284 0 0 0 0 0.515598878 0 0 0 0 0.526098279 0 0 0 0.07 0",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-6.8%",
    y: "-4.6%",
    width: "113.6%",
    height: "108.9%",
    filterUnits: "objectBoundingBox",
    id: _id7
  }, _feOffset7 || (_feOffset7 = /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur7 || (_feGaussianBlur7 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix7 || (_feColorMatrix7 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.511512284 0 0 0 0 0.515598878 0 0 0 0 0.526098279 0 0 0 0.07 0",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-3.7%",
    y: "-3.1%",
    width: "107.4%",
    height: "102.8%",
    filterUnits: "objectBoundingBox",
    id: _id8
  }, _feOffset8 || (_feOffset8 = /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur8 || (_feGaussianBlur8 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix8 || (_feColorMatrix8 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.511512284 0 0 0 0 0.515598878 0 0 0 0 0.526098279 0 0 0 0.07 0",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-3.7%",
    y: "-3.1%",
    width: "107.4%",
    height: "102.8%",
    filterUnits: "objectBoundingBox",
    id: _id9
  }, _feOffset9 || (_feOffset9 = /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur9 || (_feGaussianBlur9 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix9 || (_feColorMatrix9 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.511512284 0 0 0 0 0.515598878 0 0 0 0 0.526098279 0 0 0 0.07 0",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-3.7%",
    y: "-3.1%",
    width: "107.4%",
    height: "102.8%",
    filterUnits: "objectBoundingBox",
    id: _id10
  }, _feOffset10 || (_feOffset10 = /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur10 || (_feGaussianBlur10 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix10 || (_feColorMatrix10 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.511512284 0 0 0 0 0.515598878 0 0 0 0 0.526098279 0 0 0 0.07 0",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-3.7%",
    y: "-3.1%",
    width: "107.4%",
    height: "102.8%",
    filterUnits: "objectBoundingBox",
    id: _id11
  }, _feOffset11 || (_feOffset11 = /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur11 || (_feGaussianBlur11 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix11 || (_feColorMatrix11 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.511512284 0 0 0 0 0.515598878 0 0 0 0 0.526098279 0 0 0 0.07 0",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-7.7%",
    y: "-5.1%",
    width: "115.4%",
    height: "110.8%",
    filterUnits: "objectBoundingBox",
    id: _id12
  }, _feOffset12 || (_feOffset12 = /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur12 || (_feGaussianBlur12 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix12 || (_feColorMatrix12 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.511512284 0 0 0 0 0.515598878 0 0 0 0 0.526098279 0 0 0 0.07 0",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("path", {
    id: _id13,
    d: "M276.575 125.916l-4.628 2.432.883-5.15-3.744-3.648 5.175-.752 2.314-4.686 2.314 4.686 5.174.752-3.744 3.647.884 5.151z"
  }), /*#__PURE__*/React.createElement("path", {
    id: _id14,
    d: "M172.244 64.434l-4.05 2.128.774-4.507-3.276-3.192 4.527-.658 2.025-4.1 2.025 4.1 4.528.658-3.277 3.192.774 4.507z"
  }), /*#__PURE__*/React.createElement("path", {
    id: _id15,
    d: "M352.362 300.527l-4.05 2.128.774-4.507-3.276-3.192 4.527-.658 2.025-4.1 2.025 4.1 4.528.658-3.277 3.192.774 4.507z"
  }), /*#__PURE__*/React.createElement("path", {
    id: _id16,
    d: "M292.323 109.685l-6.364 3.344 1.215-7.083-5.148-5.015 7.115-1.034 3.182-6.444 3.182 6.444 7.115 1.034-5.149 5.015 1.216 7.083z"
  }), /*#__PURE__*/React.createElement("path", {
    id: _id17,
    d: "M44.291 367.42L33.3 373.196l2.1-12.234-8.893-8.663 12.29-1.785 5.495-11.13 5.496 11.13 12.29 1.785-8.893 8.663 2.1 12.234z"
  }), /*#__PURE__*/React.createElement("path", {
    id: _id18,
    d: "M10.827 417.59l-6.364 3.343 1.215-7.082-5.148-5.016 7.115-1.033 3.182-6.444 3.182 6.444 7.115 1.033-5.149 5.016 1.216 7.082z"
  }), /*#__PURE__*/React.createElement("path", {
    id: _id19,
    d: "M14.764 204.122L8.4 207.466l1.215-7.082-5.148-5.016 7.115-1.034 3.182-6.443 3.182 6.443 7.115 1.034-5.149 5.016 1.216 7.082z"
  }), /*#__PURE__*/React.createElement("path", {
    id: _id20,
    d: "M23.13 169.938l-9.546 5.016 1.823-10.624-7.722-7.524 10.672-1.55 4.773-9.665 4.773 9.665 10.672 1.55-7.722 7.524 1.823 10.624z"
  }), /*#__PURE__*/React.createElement("path", {
    id: _id21,
    d: "M358.76 407.998l-9.546 5.016 1.823-10.624-7.722-7.523 10.672-1.55 4.773-9.666 4.773 9.666 10.672 1.55-7.723 7.523 1.824 10.624z"
  }), /*#__PURE__*/React.createElement("path", {
    id: _id22,
    d: "M336.122 262.408l-9.546 5.015L328.4 256.8l-7.722-7.524 10.672-1.55 4.773-9.666 4.773 9.666 10.672 1.55-7.722 7.524 1.823 10.623z"
  }), /*#__PURE__*/React.createElement("path", {
    id: _id23,
    d: "M104.823 24.347l-9.546 5.016L97.1 18.739l-7.722-7.523 10.672-1.55L104.823 0l4.773 9.666 10.672 1.55-7.723 7.523 1.824 10.624z"
  }), /*#__PURE__*/React.createElement("path", {
    id: _id24,
    d: "M156.496 78.698l-5.785 3.04 1.105-6.439-4.68-4.56 6.467-.94 2.893-5.857 2.893 5.858 6.468.94-4.68 4.559 1.104 6.439z"
  })));
}
export default SvgBgMagicIcon;